exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-78dac064] .full-screen-modal .modal-dialog .modal-content{box-shadow:none!important}", ""]);

